import API from "@irati/utils/services/API"
import endpoints from "../endpoints"

export const getReferenceData = () => {
  return API.get(endpoints.reference()).then(({data}) => data)
}

export const getReward = (uuid) => {
  return API.get(endpoints.reward(uuid)).then(({data}) => data)
}

export const getRewardsWithParams = (endpoint) => {
  return API.get(endpoint).then(({data}) => data)
}

export const getRewards = (params) => {
  return API.get(endpoints.rewards(), {params}).then(({data}) => data)
}

export const createReward = (rewardData) => {
  return API.post(endpoints.rewards(), rewardData).then(({data}) => data)
}

export const putReward = (uuid, rewardData) => {
  return API.put(endpoints.reward(uuid), rewardData).then(({data}) => data)
}

export const saveReward = (rewardUuid, data) => {
  const products = data.products
    ? data.products.map((product) => {
      const {uuid, price, currency} = product
      return {uuid, price, currency}
    })
    : []
  const parsedData = {...data, products}
  return API.put(endpoints.reward(rewardUuid), parsedData).then(() => getReward(rewardUuid))
}

export default {
  getReward,
  getRewards
}
